<template>
  <vc-calendar
      :from-page.sync="page"
      :masks="{weekdays: 'WWW'}"
      :attributes="attributes"
      :is-expanded="true"
      :max-date="maxDate"
      @dayclick="$emit('dayclick', $event)"/>
</template>

<script>
import {DateTime, Duration} from "luxon";
import {mapActions} from "vuex";

const attributesFromAvailabilities = function (availabilites, minDate) {
  return availabilites.map(a => {
    const attr = {...a}
    attr.dates = a.date
    if (new Date(a.date) >= minDate) {
      let _class = 'bg-success'
      if (a.state === 'constrained')
        _class = 'bg-warning'
      if (a.state === 'closed')
        _class = 'bg-danger'
      attr.highlight = {
        class: _class,
        fillMode: 'solid'
      }
    }
    return attr
  })
}

export default {
  props: {
    selectedDate: Object,
    /**
     * Tage vor minDate werden nicht eingefärbt (vergangene Tage sind nicht
     * buchbar). Default: heute 00:00. Ohne Default würde der Vergleich
     * `new Date(...) >= undefined` immer false ergeben — Folge: keine Tagesfarben.
     */
    minDate: {
      type: Date,
      default() {
        return DateTime.local().startOf('day').toJSDate()
      }
    },
    maxDate: {
      type: Date,
      default() {
        return DateTime.local().plus(Duration.fromObject({years: 5})).toJSDate()
      }
    },
    updated: Number
  },
  data() {
    return {
      month: DateTime.local().month,
      year: DateTime.local().year,
      availabilities: [],
      blockedTimes: null
    }
  },
  computed: {
    page: {
      get: function () {
        return {month: this.month, year: this.year}
      },
      set({month, year}) {
        this.month = month
        this.year = year
      }
    },
    attributes() {
      const attributes = attributesFromAvailabilities(this.availabilities, this.minDate)
      attributes.push({
        highlight: true,
        dates: this.selectedDate?.toString()
      })
      return attributes
    }
  },
  watch: {
    page() {
      this.loadAvailabilities()
    },
    selectedDate(newDate) {
      if (newDate) {
        this.month = newDate.month
        this.year = newDate.year
      }
    },
    updated(){
      this.loadAvailabilities()
    }
  },
  methods: {
    ...mapActions(['startLoading', 'stopLoading']),
    async loadAvailabilities() {
      // Hinweis: Der Monats-Endpoint nimmt keinen channel-Parameter mehr entgegen.
      this.availabilities = await this.$api.get(`/availabilities/${this.year}/${this.month}`)
          .then(response => response.data)
          .catch(err => this.handleError(err)) || []
    }
  },
  mounted() {
    this.loadAvailabilities()
  }
}
</script>